import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CustomerArAgingFragment = { __typename?: 'CustomerArAging', current: number, days1To30: number, days31To60: number, days61To90: number, days90Plus: number };

export type CustomerOrderStatsFragment = { __typename?: 'CustomerOrderStats', totalOrderCount: number, lifetimeOrderValue: number, amountPaid: number, ytdOrderValue: number, averageOrderValue: number, lastOrderDate?: Types.TDateISO | null, arBalance: number, aging: { __typename?: 'CustomerArAging', current: number, days1To30: number, days31To60: number, days61To90: number, days90Plus: number } };

export type GetCustomerOrderStatsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']['input'];
}>;


export type GetCustomerOrderStatsQuery = { __typename?: 'Query', customerOrderStats?: { __typename?: 'CustomerOrderStats', totalOrderCount: number, lifetimeOrderValue: number, amountPaid: number, ytdOrderValue: number, averageOrderValue: number, lastOrderDate?: Types.TDateISO | null, arBalance: number, aging: { __typename?: 'CustomerArAging', current: number, days1To30: number, days31To60: number, days61To90: number, days90Plus: number } } | null };

export type CustomerTopSkuFragment = { __typename?: 'CustomerTopSku', sku: string, name: string, quantity: number, revenue: number };

export type GetCustomerTopSkusQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']['input'];
  top?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetCustomerTopSkusQuery = { __typename?: 'Query', customerTopSkus: Array<{ __typename?: 'CustomerTopSku', sku: string, name: string, quantity: number, revenue: number }> };

export type CustomerActivityEntryFragment = { __typename?: 'CustomerActivityEntry', id: string, kind: Types.CustomerActivityKind, occurredAt: Types.TDateISO, orderId?: string | null, orderNumber?: string | null, source?: Types.OrderPaymentSource | null, actedBy?: string | null, text?: string | null, amount?: { __typename?: 'MoneyData', currency: string, amount: number } | null };

export type GetCustomerActivityFeedQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCustomerActivityFeedQuery = { __typename?: 'Query', customerActivityFeed?: { __typename?: 'CustomerActivityFeedConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomerActivityEntry', id: string, kind: Types.CustomerActivityKind, occurredAt: Types.TDateISO, orderId?: string | null, orderNumber?: string | null, source?: Types.OrderPaymentSource | null, actedBy?: string | null, text?: string | null, amount?: { __typename?: 'MoneyData', currency: string, amount: number } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const CustomerArAgingFragmentDoc = new TypedDocumentString(`
    fragment CustomerArAging on CustomerArAging {
  current
  days1To30
  days31To60
  days61To90
  days90Plus
}
    `, {"fragmentName":"CustomerArAging"});
export const CustomerOrderStatsFragmentDoc = new TypedDocumentString(`
    fragment CustomerOrderStats on CustomerOrderStats {
  totalOrderCount
  lifetimeOrderValue
  amountPaid
  ytdOrderValue
  averageOrderValue
  lastOrderDate
  arBalance
  aging {
    ...CustomerArAging
  }
}
    fragment CustomerArAging on CustomerArAging {
  current
  days1To30
  days31To60
  days61To90
  days90Plus
}`, {"fragmentName":"CustomerOrderStats"});
export const CustomerTopSkuFragmentDoc = new TypedDocumentString(`
    fragment CustomerTopSku on CustomerTopSku {
  sku
  name
  quantity
  revenue
}
    `, {"fragmentName":"CustomerTopSku"});
export const CustomerActivityEntryFragmentDoc = new TypedDocumentString(`
    fragment CustomerActivityEntry on CustomerActivityEntry {
  id
  kind
  occurredAt
  orderId
  orderNumber
  amount {
    ...MoneyAmount
  }
  source
  actedBy
  text
}
    fragment MoneyAmount on MoneyData {
  currency
  amount
}`, {"fragmentName":"CustomerActivityEntry"});
export const GetCustomerOrderStatsDocument = new TypedDocumentString(`
    query GetCustomerOrderStats($customerId: String!) {
  customerOrderStats(customerId: $customerId) {
    ...CustomerOrderStats
  }
}
    fragment CustomerArAging on CustomerArAging {
  current
  days1To30
  days31To60
  days61To90
  days90Plus
}
fragment CustomerOrderStats on CustomerOrderStats {
  totalOrderCount
  lifetimeOrderValue
  amountPaid
  ytdOrderValue
  averageOrderValue
  lastOrderDate
  arBalance
  aging {
    ...CustomerArAging
  }
}`);
export const GetCustomerTopSkusDocument = new TypedDocumentString(`
    query GetCustomerTopSkus($customerId: String!, $top: Int) {
  customerTopSkus(customerId: $customerId, top: $top) {
    ...CustomerTopSku
  }
}
    fragment CustomerTopSku on CustomerTopSku {
  sku
  name
  quantity
  revenue
}`);
export const GetCustomerActivityFeedDocument = new TypedDocumentString(`
    query GetCustomerActivityFeed($customerId: String!, $first: Int, $after: String) {
  customerActivityFeed(customerId: $customerId, first: $first, after: $after) {
    nodes {
      ...CustomerActivityEntry
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment CustomerActivityEntry on CustomerActivityEntry {
  id
  kind
  occurredAt
  orderId
  orderNumber
  amount {
    ...MoneyAmount
  }
  source
  actedBy
  text
}
fragment MoneyAmount on MoneyData {
  currency
  amount
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCustomerOrderStats: build.query<GetCustomerOrderStatsQuery, GetCustomerOrderStatsQueryVariables>({
      query: (variables) => ({ document: GetCustomerOrderStatsDocument, variables })
    }),
    GetCustomerTopSkus: build.query<GetCustomerTopSkusQuery, GetCustomerTopSkusQueryVariables>({
      query: (variables) => ({ document: GetCustomerTopSkusDocument, variables })
    }),
    GetCustomerActivityFeed: build.query<GetCustomerActivityFeedQuery, GetCustomerActivityFeedQueryVariables>({
      query: (variables) => ({ document: GetCustomerActivityFeedDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCustomerOrderStatsQuery, useLazyGetCustomerOrderStatsQuery, useGetCustomerTopSkusQuery, useLazyGetCustomerTopSkusQuery, useGetCustomerActivityFeedQuery, useLazyGetCustomerActivityFeedQuery } = injectedRtkApi;
